import { gql } from '@apollo/client';

export const GENERATE_PICKUP_RESERVATION_DETAIL_DOWNLOAD = gql`
    mutation GeneratePickupReservationDetailDownloadReport($input: PickupDashboardDetailQueryInput!, $timezone: String) {
        generatePickupReservationDetailDownloadReport(input: $input, timezone: $timezone)
    }
`;
